import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "external"],
  _excluded2 = ["children", "external"];
import HubSpotAppLink from 'crm-links/common/components/HubSpotAppLink';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { LINK as MODE_LINK } from '../../constants/CardActionDisplayMode';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardActionIcon } from './CardActionIcon';
import { ExternalLinkIcon } from 'foundations-assets/icons/components/ExternalLinkIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LinkModeLabelComponent = _ref => {
  let {
      children,
      external
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Button, Object.assign({
    size: "extra-small",
    use: "link"
  }, rest, {
    children: [children, external && /*#__PURE__*/_jsx(ExternalLinkIcon, {})]
  }));
};
const LinkModeIconComponent = props => {
  return /*#__PURE__*/_jsx(IconButton, Object.assign({
    size: "small",
    use: "link"
  }, props));
};
const ButtonModeLabelComponent = _ref2 => {
  let {
      children,
      external
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(Button, Object.assign({
    size: "extra-small",
    use: "tertiary-light"
  }, rest, {
    children: [children, external && /*#__PURE__*/_jsx(ExternalLinkIcon, {})]
  }));
};
const ButtonModeIconComponent = props => {
  return /*#__PURE__*/_jsx(IconButton, Object.assign({
    size: "extra-small",
    use: "tertiary-light"
  }, props));
};
export default function HubSpotAppLinkAction({
  actionConfig,
  mode
}) {
  const LinkComp = mode === MODE_LINK ? actionConfig.label ? LinkModeLabelComponent : LinkModeIconComponent : actionConfig.label ? ButtonModeLabelComponent : ButtonModeIconComponent;
  return /*#__PURE__*/_jsxs(HubSpotAppLink, {
    linkType: actionConfig.linkType,
    linkTypeProps: actionConfig.linkTypeProps,
    LinkComponent: LinkComp,
    onTrackClick: actionConfig.onTrackClick,
    children: [actionConfig.iconName && /*#__PURE__*/_jsx(CardActionIcon, {
      name: actionConfig.iconName
    }), actionConfig.label]
  });
}